import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { APIServiceProvider } from "./../../../common/services/api.service";

@Component({
  selector: "page-ordersdelivered",
  templateUrl: "ordersdelivered.html"
})
export class OrdersdeliveredPage {
  public collapsedata: any;
  public ordersData: any = [];
  public cashNotSubmitted: any;
  public settlementPending: any;
  public cashSettled: any;
  public cashNotSubmittedData: any;
  public settlementPendingData: any;
  public cashSettledData: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public apiService: APIServiceProvider
  ) {
    this.collapsedata = [
      {
        title: "Cash not Submitted",
        icon: "md-add-circle",
        showDetails: false,
        data: this.cashNotSubmittedData
      },
      {
        title: "Settlement Pending",
        icon: "md-add-circle",
        showDetails: false,
        data: this.settlementPendingData
      },
      {
        title: "Cash Settled",
        icon: "md-add-circle",
        showDetails: false,
        data: this.cashSettledData
      }
    ];

    this.cashNotSubmitted = {
      where: "submitted_to = 1088",
      limit: "150",
      offset: "0",
      RequestType: "get_cash_not_submitted_orders"
    };

    this.settlementPending = {
      where: "order_status = 4 AND dispatched_to = 1088 AND C.status = -1",
      transaction_where: "assigned_user_id = 1088",
      limit: "150",
      offset: "0",
      RequestType: "get_cash_submitted_orders"
    };

    this.cashSettled = {
      where: "order_status = 4 AND dispatched_to = 1088 AND C.status = 1",
      transaction_where: "assigned_user_id = 1088",
      limit: "150",
      offset: "0",
      RequestType: "get_cash_submitted_orders"
    };
  }

  toggleDetails(collapsedata) {
    if (collapsedata.showDetails) {
      collapsedata.showDetails = false;
      collapsedata.icon = "md-add-circle";
    } else {
      collapsedata.showDetails = true;
      collapsedata.icon = "md-remove-circle";
    }
  }

  ionViewDidLoad() {
    this.getCashNotSubmittedOrders(this.cashNotSubmitted, 0);
    this.getCashNotSubmittedOrders(this.settlementPending, 1);
    this.getCashNotSubmittedOrders(this.cashSettled, 2);
  }

  getCashNotSubmittedOrders(postParms, index) {
    this.apiService.post(postParms).subscribe(data => {
      this.collapsedata[index].data = data["results"]["records"]["orders"];
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders/ordersdelivered/ordersdelivered.ts